<template>
<div class="col-12 px-0">
  <div class="row mx-0">
    <div class="col-12 px-0">
      <h5 :class="{ 'mb-2': isPioneer || isEmployee, 'mb-0': !isPioneer && !isEmployee  }">
        Hi {{ first_name }}
      </h5>
      <div v-if="isPioneer || isEmployee"
        :class="{
          'sidebar-user-status': true,
          'pioneer': isPioneer && !isEmployee,
          'employee': isEmployee && !isPioneer,
          'both': isPioneer && isEmployee
        }"
      >
        <div v-if="isPioneer && !isEmployee" style="position: relative;z-index: 1;">
          <span class="d-inline">Pioneer</span>
          <img
            class="sidebar-user-status-info-icon pl-2 fillable d-inline hand-pointer"
            src="/assets/icons/fillable/info_icon.svg"
            alt="open pioneer status modal"
            style="margin-top: -2px;"
            @click="openModal(isMobileXsSm ? 1 : 0)"
          >
        </div>
        <div v-else-if="isEmployee && !isPioneer" style="position: relative;z-index: 1;">
          <span class="d-inline">Employee</span>
          <img
            class="sidebar-user-status-info-icon pl-2 fillable d-inline hand-pointer"
            src="/assets/icons/fillable/info_icon.svg"
            alt="open pioneer status modal"
            @click="openModal(isMobileXsSm ? 1 : 0)"
          >
        </div>
        <div v-else>
          <div class="d-inline-block">
            <div class="pioneer" style="position: relative;z-index: 1;">
              <span>Pioneer</span>
            </div>
          </div>
          <div class="d-inline-block">
            <div class="employee" style="position: relative;z-index: 1;">
              <span class="d-inline">Employee</span>
              <img
                class="sidebar-user-status-info-icon pl-2 fillable d-inline hand-pointer"
                src="/assets/icons/fillable/info_icon.svg"
                alt="open pioneer status modal"
                @click="openModal(isMobileXsSm ? 1 : 0)"
              >
            </div>
          </div>
        </div>
      </div>
      <AccountSubscriptionsList/>
    </div>
  </div>
</div>
<!-- Pioneer and Employee Modals -->
<DesktopOverlay :is_active="overlay_control_vars[0]" @overlay-click="flipOverlay(0)">
  <template #overlayContent>
    <div class="account-new-header-popup">
      <div class="account-new-header-popup-content row mx-0">
        <div class="col-12 px-0">
          <img
            class="ml-auto hand-pointer"
            src="/assets/icons/primary/close_basket.svg"
            width="15"
            height="15"
            alt="close roast popup"
            @click="flipOverlay(0)"
          />
        </div>
        <div class="col-12 px-0 pt-4">
          <p v-if="isPioneer" class="account-new-header-popup-text mb-0">
            You’re a Pact Pioneer which means you get £1 off of every subscription order.
            <span v-if="isEmployee">You also receive a work perk discount on every order of £{{ parseFloat(employee_discount).toFixed(2) }}.</span>
          </p>
          <p v-else-if="isEmployee" class="account-new-header-popup-text mb-0">
            You receive a work perk discount on every order of £{{ parseFloat(employee_discount).toFixed(2) }}.
          </p>
        </div>
      </div>
    </div>
  </template>
</DesktopOverlay>
<MobileOverlayFull :is_active="overlay_control_vars[1]" @overlay-click="flipOverlay(1)">
  <template #overlayContent>
    <div class="account-new-header-popup mob">
      <div class="account-new-header-popup-content row mx-0">
        <div class="col-12 px-0">
          <img
            class="ml-auto hand-pointer"
            src="/assets/icons/primary/close_basket.svg"
            width="15"
            height="15"
            alt="close roast popup"
            @click="flipOverlay(1)"
          />
        </div>
        <div class="col-12 px-0 py-4">
          <p v-if="isPioneer" class="account-new-header-popup-text mb-0">
            You’re a Pact Pioneer which means you get £1 off of every subscription order.
            <span v-if="isEmployee">You also receive a work perk discount on every order of £{{ parseFloat(employee_discount).toFixed(2) }}.</span>
          </p>
          <p v-else-if="isEmployee" class="account-new-header-popup-text mb-0">
            You receive a work perk discount on every order of £{{ parseFloat(employee_discount).toFixed(2) }}.
          </p>
        </div>
      </div>
    </div>
  </template>
</MobileOverlayFull>
<!-- End Pioneer and Employee Modals -->
</template>
<script setup>
import { defineAsyncComponent, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthUser } from '../../../utils/stores/modules/authUser'
import AccountSubscriptionsList from './accountSubscriptionsList.vue'
import { useMultipleOverlays } from '../../utils/Overlays/multipleOverlayHelpers'
import { useMobileHelpers } from '../../utils/composables/mobileHelpers'

const DesktopOverlay = defineAsyncComponent(() => import('../../utils/Overlays/DesktopOverlay.vue'))
const MobileOverlayFull = defineAsyncComponent(() => import('../../utils/Overlays/MobileOverlayFull.vue'))

const userStore = useAuthUser()
const route = useRoute()
// Props (defineProps)
// Emits (defineEmits)
// Reactive variables (inc composables)
const { overlay_control_vars, flipOverlay } = useMultipleOverlays(2)
const { isMobileXsSm } = useMobileHelpers()
// Computed
const first_name = computed(() => userStore.firstName)
const isPioneer = computed(() => userStore.isPioneer)
const isEmployee = computed(() => userStore.userEmployeeDiscount !== undefined && userStore.userEmployeeDiscount > 0)
const employee_discount = computed(() => userStore.employee_discount)
// Methods
function openModal(id) {
  flipOverlay(id)
}
// Watchers
// Lifecycle Hooks
// Expose (defineExpose)
</script>
<script>
export default {
	name: 'AccountNewHeader',
}
</script>
<style lang="scss" scoped>
@use '../../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;

  // @include target-md-plus{
  //   min-height: 110px;
  // }

  h5 {
    color: #1D4045;
    /* LG-B */
    font-family: 'Apercu';
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
    letter-spacing: 0px;

    @include target-md {
      font-size: 28px;
      line-height: 36px;
    }
  }

  .sidebar-user-status{
    margin-bottom: 10px;
    position: relative;
    span{
      color: #373A3D;
      text-align: right;
      /* XS-M */
      font-family: 'Apercu-medium';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      position: relative;
      top: 0px; //-1px;
    }

    &.pioneer{
      background-color: #ffca9a;
      width: 90px;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      height: 24px;
      &::before{
        content: "";
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100vw;
        margin-left: calc(50% - 104vw);
        height: 24px;
        background-color: #ffca9a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }
    }
    &.employee{
      background-color: #CCD2FF;
      width: 100px;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      height: 24px;
      &::before{
        content: "";
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100vw;
        margin-left: calc(50% - 104vw);
        height: 24px;
        background-color: #CCD2FF;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }
    }

    &.both{
      &::before{
        content: "";
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100vw;
        margin-left: calc(50% - 104vw);
        height: 24px;
        background-color: #ffca9a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }

      .pioneer{
        background-color: #ffca9a;
        width: 65px;
        height: 24px;
        padding-right: 5px;

        @include target-md-lg{
          width: 60px;
        }
      }

      .employee{
        background-color: #CCD2FF;
        width: 110px;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
        height: 24px;
        padding-left: 10px;

        @include target-md-lg{
          width: 105px;
          padding-left: 5px;
        }
      }
    }
  }

  .number-of-subscriptions-info{
    p{
      color: #646668;
      /* XS-M */
      font-family: 'Apercu-medium';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      letter-spacing: 0px;
    }

    &-btn{
      background-color: #E9E9E9;
      color: #1D4045;
      min-width: 77px !important;
      max-width: 77px !important;
      height: 26px;
      line-height: 26px;
      letter-spacing: 1px !important;
      padding: 0px 8px;
      border-radius: 4px;
    }
  }

  .account-new-header-popup {
    max-width: 400px;
    min-height: 180px;
    // max-height: 405px;
    margin: 0px auto;
    padding: 32px;
    background-color: #fff;
    transition: all 0.3s ease;

    @include target-md{
      max-width: 720px;
    }

    &.mob {
      position: relative;
      top: 50%;
      transform: translate(0, -50%);
      max-width: 334px;
      min-height: fit-content; // 492px;
      padding: 20px;
    }

    .account-new-header-popup-content {

      .account-new-header-popup-title {
        text-transform: capitalize;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #1d4045;
        letter-spacing: 0px;
        text-align: left;

        @include target-md-plus{
          font-size: 24px;
          line-height: 32px;
        }
      }

      .account-new-header-popup-desc {
        font-weight: 300;
        font-size: 14px;
        line-height: 18px;
        color: #212427;
        padding: 0 10px 10px 10px;
        letter-spacing: 0px;

        @media (max-width: 767px) {
          padding: 0;
        }
      }

      .account-new-header-popup-content-body{
        max-height: 316px;
        overflow-y: scroll;

        @include target-md-plus{
          max-height: 250px;
          overflow-y: scroll;
        }

        &.scroller {
          scrollbar-color: #1d4045 transparent;
          scrollbar-width: thin;
          overflow-y: scroll !important;
        }

        &::-webkit-scrollbar {
          width: 3px;
          background: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #1d4045;
          border-radius: 10px;
          border: 3px solid #1d4045;
        }
      }
    }
  }
</style>